
import React from 'react';
import { Form, Input, Button, Row, Col, Icon } from 'antd';


const labelStyle = {
  fontWeight: "800",
  fontSize: "16px",
  width: '100%',
  textAlign:'left',
  whiteSpace: 'normal',
  display:'inline-flex'
};

class TradeReferencesForm extends React.Component {
  render() {
    const { references, onReferenceChange, onAddReference, onDeleteReference } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
      
        {references.map((reference, index) => (
          <Form.Item
          label={ index === 0 ?
            <span style={labelStyle}>
              Please enter companies that Prime freight may contact for
              reference purposes
            </span> : ''
          }
        >

        {getFieldDecorator("reference_company", {
                  initialValue: references,
                  rules: [{ required: true, message: "Required" }],
                })(

          <Row key={index} gutter={16}>
            <Col xs={24} sm={24} md={4}>
              <Form.Item>
                <Input
                  size="large"
                  placeholder="Company Name"
                  value={reference.companyName || ''}
                  onChange={e => onReferenceChange(index, 'companyName', e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={4}>
               <Form.Item>
                 <Input size="large" placeholder="Contact Name" 
                  value={reference.contactName || ''}
                  onChange={e => onReferenceChange(index, 'contactName', e.target.value)}
                 />
               </Form.Item>
             </Col>
            <Col xs={24} sm={24} md={4}>
              <Form.Item>
                <Input size="large" placeholder="Address" 
                  value={reference.address || ''}
                  onChange={e => onReferenceChange(index, 'address', e.target.value)}
                />
               </Form.Item>
             </Col>
             <Col xs={24} sm={24} md={4}>
               <Form.Item>
                <Input size="large" placeholder="Phone" 
                  value={reference.phone || ''}
                  onChange={e => onReferenceChange(index, 'phone', e.target.value)}
                />
               </Form.Item>
             </Col>
            <Col xs={24} sm={24} md={4}>
              <Form.Item>
                <Input size="large" placeholder="Email" 
                  value={reference.email || ''}
                  onChange={e => onReferenceChange(index, 'email', e.target.value)}
                />
              </Form.Item>
            </Col>
            {/* Other input fields */}
            <Col xs={24} sm={24} md={4}>
              {index === references.length - 1 ? (
                <Button type="dashed" onClick={onAddReference} style={{ width: '100%' }}>
                  <Icon type="plus" />
                </Button>
              ) : (
                <Button type="dashed" onClick={() => onDeleteReference(index)} style={{ width: '100%' }}>
                  <Icon type="minus" />
                </Button>
              )}
            </Col>
          </Row>

        )}
        </Form.Item>

        ))}
      </Form>
    );
  }
}

export default TradeReferencesForm;